module.exports = __webpack_public_path__ + "img/user.067ac27f.png";